import { Component, inject, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { LFProject } from '@lfw/roesberg.liveforms.core';
import { SelectionArguments } from '../../../shared/models/selection-arguments';
import { SettingsService } from '../../../shared/settings/settings.service';

@Component({
  selector: 'lfw-project-list-item',
  templateUrl: './project-list-item.component.html',
  styleUrls: ['./project-list-item.component.css'],
  imports: [MatIcon]
})
export class ProjectListItemComponent {
  readonly project = input.required<LFProject>();
  readonly projectSelected = output<SelectionArguments>();

  private readonly settings = inject(SettingsService);

  showDescription(): boolean {
    const project = this.project();
    if (project === undefined || this.settings === undefined) {
      return false;
    }
    return (
      this.settings.settings.orderSettings.showProjectDescription &&
      project.shortDescription !== undefined &&
      project.shortDescription !== ''
    );
  }
}
